var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "header__mobile",
      class: {
        "open-menu": _vm.isToggled,
        blog: _vm.isBlog,
        default: !_vm.isBlog
      }
    },
    [
      _c("div", { staticClass: "header__mobile__wrapper" }, [
        _c(
          "div",
          { staticClass: "header__inner" },
          [
            _c("header-mobile-toggle", {
              attrs: { "on-toggle": _vm.onToggleButtonPressed }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "header__logo",
                attrs: { href: "/" },
                on: {
                  click: function($event) {
                    return _vm.onMainLinkClicked("ShopKeep Logo")
                  }
                }
              },
              [_c("img", { attrs: { src: _vm.logo } })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isToggled,
                    expression: "!isToggled"
                  }
                ],
                staticClass: "header__call",
                attrs: { id: "header__phone-number" }
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "tel:+" + _vm.phone },
                    on: {
                      click: function($event) {
                        return _vm.onMainLinkClicked(_vm.phone)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.phone))]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header__mobile__links", style: _vm.headerLinksStyle },
          [
            _c("ul", { staticClass: "header__links" }, [
              _c("li", { staticClass: "header__mobile__links--left" }, [
                _c(
                  "ul",
                  { staticClass: "header__mobile__links--left-list" },
                  _vm._l(_vm.navItems.left.items, function(item) {
                    return _c(
                      "li",
                      {
                        key: item.label,
                        class: {
                          header__links__items: true,
                          "header__links__items--parent": item.children
                        }
                      },
                      [
                        !item.href
                          ? _c(
                              "p",
                              { staticClass: "header__links--parent__label" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.label) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !item.children
                          ? _c(
                              "a",
                              {
                                staticClass: "header__links--parent__label",
                                attrs: {
                                  href: item.href,
                                  "data-nav-type-text": _vm.navItems.type
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onLinkClicked(item.label)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.label))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.children
                          ? _c(
                              "ul",
                              {
                                class: {
                                  "header__links--child": true
                                }
                              },
                              _vm._l(item.children, function(child) {
                                return _c(
                                  "li",
                                  {
                                    key: child.label,
                                    staticClass: "header__links__items"
                                  },
                                  [
                                    child.href
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "header__links--child__label",
                                            attrs: {
                                              href: child.href,
                                              "data-parent-label": item.label,
                                              "data-nav-type-text":
                                                _vm.navItems.type,
                                              target: child.open_link_in_new_tab
                                                ? "_blank"
                                                : null
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onChildLinkClicked(
                                                  child.label,
                                                  item.label
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(child.label))]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "header__links--labels"
                                          },
                                          [_vm._v(_vm._s(child.label))]
                                        )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "header__mobile__links--right" }, [
                _c(
                  "ul",
                  { staticClass: "header__mobile__links--right-list" },
                  _vm._l(_vm.navItems.right.items, function(item) {
                    return _c(
                      "li",
                      {
                        key: item.label,
                        class: {
                          header__links__items: true,
                          "header__links__items--parent": item.children
                        }
                      },
                      [
                        !item.href
                          ? _c(
                              "p",
                              { staticClass: "header__links--parent__label" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.label) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !item.children
                          ? _c(
                              "a",
                              {
                                staticClass: "header__links--parent__label",
                                attrs: {
                                  href: item.href,
                                  "data-nav-type-text": _vm.navItems.type
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onLinkClicked(item.label)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.label))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.children
                          ? _c(
                              "ul",
                              {
                                class: {
                                  "header__links--child": true
                                }
                              },
                              _vm._l(item.children, function(child) {
                                return _c(
                                  "li",
                                  {
                                    key: child.label,
                                    staticClass: "header__links__items"
                                  },
                                  [
                                    child.children
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "header__links--subchild-heading-container",
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleSubchild(
                                                    child
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "header__links--child__label"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(child.label) +
                                                      "\n                      "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "header__links--subchild-arrow"
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xlink:href": `#arrow-${
                                                        _vm.isSubchildToggled(
                                                          child
                                                        )
                                                          ? "up"
                                                          : "down"
                                                      }`
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "header__links--subchild-list",
                                              style: {
                                                "max-height": _vm.isSubchildToggled(
                                                  child
                                                )
                                                  ? `${22 *
                                                      child.children.length}px`
                                                  : "0"
                                              }
                                            },
                                            _vm._l(child.children, function(
                                              subchild
                                            ) {
                                              return _c(
                                                "li",
                                                { key: subchild.label },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "header__links--subchild__label",
                                                      attrs: {
                                                        href: subchild.href,
                                                        "data-parent-label":
                                                          child.label,
                                                        "data-nav-type-text":
                                                          _vm.navItems.type,
                                                        target: subchild.open_link_in_new_tab
                                                          ? "_blank"
                                                          : null
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(subchild.label)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ])
                                      : [
                                          child.subscribe_to_blog_link
                                            ? [
                                                _vm.isWordpress
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "header__links--child__label",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.blogSubscribeTriggered()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              child.label
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.isWordpress
                                                  ? _c("header-email-signup", {
                                                      attrs: {
                                                        header: _vm.header,
                                                        label: child.label
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            : _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "header__links--child__label",
                                                  attrs: {
                                                    href: child.href,
                                                    "data-parent-label":
                                                      item.label,
                                                    "data-nav-type-text":
                                                      _vm.navItems.type
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onChildLinkClicked(
                                                        child.label,
                                                        item.label
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(child.label))]
                                              )
                                        ]
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header__mobile--bottom" }, [
              _vm.isWordpress
                ? _c("div", { staticClass: "header__mobile--bottom__left" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-mobile__nav-button-container header-mobile__nav-button-container--default"
                      },
                      [
                        _c(
                          "lightbox-button",
                          {
                            staticClass: "header__trial",
                            attrs: { target: "lightboxMarketoOptimizely" }
                          },
                          [_vm._v("Get Started")]
                        )
                      ],
                      1
                    )
                  ])
                : _c("div", { staticClass: "header__mobile--bottom__left" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-mobile__nav-button-container header-mobile__nav-button-container--default"
                      },
                      [
                        _c(
                          "optimizely-button",
                          {
                            attrs: {
                              "class-name": "header__trial",
                              target: _vm.mainForm.lightbox_target,
                              "optimizely-prefix":
                                _vm.mainForm.optimizely_prefix,
                              prefix: _vm.mainForm.ga_prefix,
                              href: "/signup"
                            }
                          },
                          [_vm._v("Get Started")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-mobile__nav-button-container header-mobile__nav-button-container--test"
                      },
                      [
                        _c(
                          "optimizely-button",
                          {
                            attrs: {
                              "class-name": "header__trial",
                              target: "lightboxStarterJunctionNav",
                              href: "/signup",
                              id: "sk-free-trial"
                            }
                          },
                          [_vm._v("Get Started")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-mobile__nav-button-container header-mobile__nav-button-container--starter-everywhere"
                      },
                      [
                        _c("nav-link-button", {
                          staticClass: "header__trial",
                          attrs: { href: "/pricing", cta: "Get Started Free" }
                        })
                      ],
                      1
                    )
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "header__mobile--bottom__right" }, [
                _c(
                  "button",
                  {
                    staticClass: "header__mobile--bottom__right--login__button",
                    on: {
                      click: function($event) {
                        return _vm.loginClicked()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.loginText) + "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }